// University at Buffalo's undergraduate majors. Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog's Majors and Combined Degrees page
// (catalogs.buffalo.edu, catoid=21 navoid=1177), read in a headless browser
// because the catalog answers plain requests with an empty 202. The catalog
// lists majors A to Z, not by school, so this is one list. A major listed once
// per concentration (Business Administration, Fine Arts, Mathematics ...)
// appears once per degree. Left out: combined degrees, Pharmacy PharmD (a
// professional doctorate first-years enter through Early Assurance), and the
// accelerated and RN to BS nursing tracks (not first-year entry); Nursing BS
// (traditional program) is listed as Nursing. Names and degree abbreviations
// are the catalog's own, including "Material Science and Engineering" and the
// eight "AI and ..." majors, whose official names use "AI". Flags quote UB's
// Special Requirements for Certain Majors page (the college file's
// `specialMajors` source). The KB's majors list was the starting point; the
// catalog wins.
const majors = {
    "slug": "university-at-buffalo-suny",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in UB's official 2026-2027 Undergraduate Catalog, with the degree it leads to. The catalog lists majors in one list, not by school; a major with several concentrations appears once. Minors, certificates, combined degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "Undergraduate majors",
            "source": {
                "label": "UB 2026-2027 Undergraduate Catalog, Majors and Combined Degrees",
                "url": "https://catalogs.buffalo.edu/content.php?catoid=21&navoid=1177"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS",
                    "flag": "Direct admission is subject to limited enrollment.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Acting",
                    "degree": "BFA",
                    "flag": "An audition is required.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "African-American Studies",
                    "degree": "BA"
                },
                {
                    "name": "AI and Geospatial Analytics",
                    "degree": "BS"
                },
                {
                    "name": "AI and Language and Intercultural Competence",
                    "degree": "BS"
                },
                {
                    "name": "AI and Language Technology",
                    "degree": "BS"
                },
                {
                    "name": "AI and Logic and Ontology",
                    "degree": "BS"
                },
                {
                    "name": "AI and Philosophy, Politics and Economics",
                    "degree": "BS"
                },
                {
                    "name": "AI and Policy Analysis",
                    "degree": "BS"
                },
                {
                    "name": "AI and Quantitative Economics",
                    "degree": "BS"
                },
                {
                    "name": "AI and Responsible Communication",
                    "degree": "BS"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Bioinformatics and Computational Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BS",
                    "flag": "Direct admission is subject to limited enrollment.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Computational Linguistics",
                    "degree": "BS"
                },
                {
                    "name": "Computational Physics",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Criminology",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA",
                    "flag": "An audition is required.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Dance",
                    "degree": "BFA",
                    "flag": "An audition is required.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Science",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Design",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Sustainability",
                    "degree": "BA"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Film Studies",
                    "degree": "BA"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Fine Arts",
                    "degree": "BFA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geographic Information Science",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Global Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Global Gender Studies",
                    "degree": "BA"
                },
                {
                    "name": "Health and Human Services",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Indigenous Studies",
                    "degree": "BA"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology and Management",
                    "degree": "BS"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "International Trade",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Law",
                    "degree": "BA"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Material Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mathematical Physics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics-Economics",
                    "degree": "BA"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Media Study",
                    "degree": "BA"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BS"
                },
                {
                    "name": "Medicinal Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA",
                    "flag": "An audition is required.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Music Performance",
                    "degree": "MusB",
                    "flag": "An audition is required.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Music Theatre",
                    "degree": "BFA",
                    "flag": "An audition is required.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Nuclear Medicine Technology",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition Science",
                    "degree": "BS"
                },
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Pharmacology and Toxicology",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics and Economics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Special Studies",
                    "degree": "BA/BS"
                },
                {
                    "name": "Speech and Hearing Science",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Design/Technology",
                    "degree": "BFA",
                    "flag": "A portfolio review and an interview are required.",
                    "flagSource": "specialMajors"
                },
                {
                    "name": "Urban and Public Policy Studies",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
